import { GridButton } from '@eforall/dashboard';


export function getButtons() {

	const buttons: GridButton[] = [
		// {
		// 	iconClass: 'fa-plus',
		// 	label: 'Add Engagement',
		// 	execute: async () => {
		// 		console.log('Add engagement button clicked');
		// 	}
		// }
	];

	return buttons;
}